import { render, staticRenderFns } from "./TableEditor.vue?vue&type=template&id=5680f1be&scoped=true&"
import script from "./TableEditor.vue?vue&type=script&lang=js&"
export * from "./TableEditor.vue?vue&type=script&lang=js&"
import style0 from "./TableEditor.vue?vue&type=style&index=0&id=5680f1be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5680f1be",
  null
  
)

export default component.exports